import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import img1 from '../assets/images/20240628_105554.jpg';
import img2 from '../assets/images/IMG_20240719_103959_150.jpg';
import img3 from '../assets/images/20240628_120910.jpg';
import img4 from '../assets/images/20240628_163451.jpg';
import img5 from '../assets/images/IMG-20240606-WA0020.jpg';
import img6 from '../assets/images/20240722_110242.jpg';
import img7 from '../assets/images/20240722_105903.jpg';
import img8 from '../assets/images/20240703_184940.jpg';
import img9 from '../assets/images/20240703_185135.jpg';
import img10 from '../assets/images/20240715_113758.jpg';
import img11 from '../assets/images/20240709_095640.jpg';
import img12 from '../assets/images/20240722_105836.jpg';

const Gallery = () => {
  useEffect(() => { 
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div id = 'gallery' className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mx-4 my-16 sm:mx-10 md:mx-20 mt-10 md:mt-20">
      {[img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12].map((img, index) => (
        <div key={index} className="w-full h-64" data-aos="fade-up">
          <img
            className="w-full h-full object-cover rounded-lg"
            src={img}
            alt={`Gallery image ${index + 1}`}
          />
        </div>
      ))}
    </div>
  );
};

export default Gallery;
